document.addEventListener("DOMContentLoaded", () => {
  const purchaseBtns = document.querySelectorAll(".purchase-type");
  const oneTimeSection = document.querySelector(".one-time-bundle");
  const subscriptionSection = document.querySelector(".subscription-bundle");

  // =========================
  // TOGGLE SECTIONS
  // =========================
  purchaseBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      purchaseBtns.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      const type = btn.dataset.type;

      if (type === "one-time") {
        oneTimeSection.classList.remove("hidden");
        subscriptionSection.classList.add("hidden");
      } else {
        subscriptionSection.classList.remove("hidden");
        oneTimeSection.classList.add("hidden");
      }
    });
  });

  const updateBundleDisplay = (targetSet) => {
    document.querySelectorAll("[data-bundle-price]").forEach((priceSpan) => {
      let newPrice = "";
      let newCompare = "";
      switch (targetSet) {
        case "set-1":
          newPrice = priceSpan.dataset.priceSet1;
          newCompare = priceSpan.dataset.compareSet1;
          break;
        case "set-2":
          newPrice = priceSpan.dataset.priceSet2;
          newCompare = priceSpan.dataset.compareSet2;
          break;
        case "set-3":
          newPrice = priceSpan.dataset.priceSet3;
          newCompare = priceSpan.dataset.compareSet3;
          break;
      }

      if (newPrice && newCompare) {
        priceSpan.innerHTML = `${newPrice} <s>${newCompare}</s>`;

        const cleanPrice = parseFloat(newPrice.replace(/[^0-9.]/g, ""));
        const cleanCompare = parseFloat(newCompare.replace(/[^0-9.]/g, ""));

        if (cleanCompare > cleanPrice) {
          const discount = ((cleanCompare - cleanPrice) / cleanCompare) * 100;
          const formattedDiscount = Math.round(discount);
          const savedEl = document.querySelector("[data-saved-percentage]");
          if (savedEl) savedEl.textContent = `Save ${formattedDiscount}%`;
        }
      }
    });
  };

  // =========================
  // BUNDLE SELECTOR SWITCHER
  // =========================
  document.querySelectorAll(".bundle-selector").forEach((selector) => {
    const buttons = selector.querySelectorAll(".bundle-option");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        buttons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        const parent = selector.nextElementSibling;
        parent
          .querySelectorAll(".bundle-group")
          .forEach((g) => g.classList.add("hidden"));
        parent
          .querySelector(`[data-bundle-set="${btn.dataset.target}"]`)
          .classList.remove("hidden");

        updateBundleDisplay(btn.dataset.target);
      });
    });
  });

  // 2️⃣ Run once on page load based on default set
  const priceSpan = document.querySelector("[data-bundle-price]");
  if (priceSpan) {
    const defaultSet = priceSpan.dataset.defaultSet;
    const defaultTarget = `set-${defaultSet}`;
    updateBundleDisplay(defaultTarget);
  }

  // =========================
  // GLOBAL UPSell STATE
  // =========================
  let selectedUpsell = null;

  document
    .getElementById("add-upsell-onetime")
    .addEventListener("click", (e) => {
      const upsellEl = document.querySelector(".upsell-prod");
      const upsellId = Number(upsellEl.dataset.variantId);
      if (upsellId) {
        selectedUpsell = upsellId;
        e.target.textContent = "Added ✓";
        e.target.disabled = true;
        console.log("✅ Upsell selected:", upsellId);
      }
    });

  // =========================
  // GENERIC BUNDLE BUILDER
  // =========================
  async function buildBundle(
    groupSelector,
    isSubscription = true,
    includeUpsell = null
  ) {
    const activeGroup = groupSelector.querySelector(
      ".bundle-group:not(.hidden)"
    );
    if (!activeGroup) return alert("Please select a bundle first.");

    // 🧩 Parent data
    const product_id = activeGroup.dataset.product;
    const variant_id = activeGroup.dataset.variant;
    const sku = activeGroup.dataset.sku;
    const sellingPlan = isSubscription ? activeGroup.dataset.sellingPlan : null;

    // 🧩 Child selections
    const rawSelections = [];
    activeGroup.querySelectorAll(".bundle-product[data-id]").forEach((el) => {
      const collectionId = el.dataset.collection;
      const productId = el.dataset.product;
      const variantId = el.dataset.id;
      const title = el.querySelector("p")?.innerText?.trim() || "Item";
      if (!collectionId || !productId || !variantId) return;
      rawSelections.push({
        collectionId: String(collectionId),
        externalProductId: String(productId),
        externalVariantId: String(variantId),
        title,
      });
    });

    if (rawSelections.length === 0) {
      alert("Please choose your bundle items first.");
      return;
    }

    // Group duplicates
    const grouped = {};
    rawSelections.forEach((item) => {
      const key = `${item.externalProductId}_${item.externalVariantId}`;
      if (!grouped[key]) grouped[key] = { ...item, quantity: 1 };
      else grouped[key].quantity++;
    });

    const selections = [];
    const contents = [];
    Object.values(grouped).forEach((i) => {
      selections.push({
        collectionId: i.collectionId,
        externalProductId: i.externalProductId,
        externalVariantId: i.externalVariantId,
        quantity: i.quantity,
      });
      contents.push(`${i.quantity}x ${i.title}`);
    });

    // ⭐️ AUTO ADD UV LAMP (ONE-TIME ONLY)
    if (!isSubscription) {
      selections.push({
        collectionId: "472459477310",
        externalProductId: "8821075804478",
        externalVariantId: "45814640869694",
        quantity: 1,
      });

      contents.push(`1x UV LED Lamp`);
    }

    const contentsString = contents.join("\n");

    // 🧩 Build Recharge bundle data
    const bundleData = {
      externalProductId: String(product_id),
      externalVariantId: String(variant_id),
      selections: selections,
    };

    let rbId;
    try {
      rbId = await recharge.bundle.getBundleId(bundleData);
      console.log("✅ Generated Recharge-like bundle ID:", rbId);
      console.log("✅ Bundle Data:", bundleData);
    } catch (err) {
      console.error("❌ Bundle generation failed:", err);
      alert("Error creating bundle. Please try again.");
      return;
    }

    // 🛒 Build parent bundle item
    const parentItem = {
      id: Number(variant_id),
      quantity: 1,
      properties: {
        _rb_id: rbId,
        Content: contentsString,
      },
    };
    if (isSubscription && sellingPlan)
      parentItem.selling_plan = Number(sellingPlan);

    // 🧩 Include upsell if selected (only for one-time)
    // 🧩 Final cart items
    const finalItems = [parentItem];

    // ➕ Add upsell as a NORMAL product (no parent, no bundle)
    if (!isSubscription && includeUpsell) {
      finalItems.push({
        id: Number(includeUpsell),
        quantity: 1,
        properties: {},
      });

      console.log("➕ Upsell added as normal product:", includeUpsell);
    }


    // =========================
    // ADD TO CART
    // =========================
    try {
      const formData = new FormData();

      finalItems.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity);

        if (item.selling_plan) {
          formData.append(`items[${index}][selling_plan]`, item.selling_plan);
        }

        Object.keys(item.properties).forEach((propKey) => {
          formData.append(
            `items[${index}][properties][${propKey}]`,
            item.properties[propKey]
          );
        });
      });

      const res = await fetch("/cart/add", {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        console.log(
          "✅ Bundle successfully added (Recharge expansion triggered)"
        );

        if (!isSubscription) {
          selectedUpsell = null;
          const upsellBtn = document.getElementById("add-upsell-onetime");
          upsellBtn.textContent = "Add +";
          upsellBtn.disabled = false;
        }
      } else {
        console.error("❌ Add-to-cart error:", res);
        alert("Error adding bundle to cart.");
      }
    } catch (err) {
      console.error("❌ Fetch error:", err);
    }
  }

  // =========================
  // ADD BUTTONS
  // =========================
  document
    .getElementById("add-bundle-onetime")
    .addEventListener("click", async () => {
      await buildBundle(oneTimeSection, false, selectedUpsell);
    });

  document
    .getElementById("add-bundle-subscription")
    .addEventListener("click", async () => {
      await buildBundle(subscriptionSection, true);
    });
});
